/**
 * Updated by Chen on 2019/2/22.
 */
import './style.scss'
import React, {Component} from 'react'
import StateTypes from  '../../../constants/StateTypes'
import { message, Button } from 'antd'
const dashBoardTypes = StateTypes.app.dashboard
const userInfoType = StateTypes.app.customers.userInfo;
import config from '../../../config'
import {getStore} from '../../../store.js'
import {currentCallActions} from '../../../actions'
import {connect} from 'react-redux'
import { sendTrtcMessageTowxSmallProgram } from '../../../utils/txfit';

/**
 * SessionAction component.
 * Handles actions for the current active session (primarily calls)
 */
class LossKandySessionAction extends Component {
    constructor(props) {
        super(props)
        this.state = {
            StartBtn: false,
            sessionStarted: [],
            screenSharingExist: false,
            visible:false
        }
    }

    componentDidMount(){
        
        window.addEventListener("message", this.receiveMessage, false);
    }
    receiveMessage = (event) => {
        const data = event.data
        if (data.eventName === 'toggleSession') {
            this.toggleSession()       
        }
    }
    componentWillUnmount() {
        window.removeEventListener("message", this.receiveMessage, false);
    }
    UNSAFE_componentWillMount() {
        this.isExist(config.chromeExtensionId, this.chromeExtensionInstalledCallback.bind(this))
    }

    chromeExtensionInstalledCallback(installed) {
        if (installed) {
            this.setState({screenSharingExist: true})
        } else {

            this.setState({screenSharingExist: false})
        }
    }

    isExist(extensionId, callback) {
        try {
            chrome.runtime.sendMessage(extensionId, {message: "version"},
            (reply) => {
                if (reply) {
                    callback(true);
                } else {
                    callback(false);
                }
            })
        } catch {
            
        }
    }


    doCustomerDisconnected() {
        const {actions, currentAgent, customer, call} = this.props
        if (customer.isSessionActive) {
            // End the call if it is ongoing for the current customer
            if (call && customer.isCallOn) {
                actions.endKandyCall(customer.userId, call.callId)
            }
            actions.endSessionByPicc(customer._id)
        }
    }

    async toggleSession() {
        const {actions, currentAgent, customer, call, serviceRequests, company, wxSmallProgramRequest, conference} = this.props

        if(customer.channelType == 'wxSmallProgram' && !(customer.isSessionActive)){
            //微信小程序渠道
            var tmpSessionStarted = this.state.sessionStarted;
            if (!tmpSessionStarted[customer.userId]) {
                tmpSessionStarted[customer.userId] = true
                this.setState({
                    sessionStarted: tmpSessionStarted
                });
            }
            else {
                return false
            }
            let rs = await actions.startSessionByPicc(customer._id, company.waitTime, currentAgent)
            /* 接听失败直接做挂断处理*/
            if (rs.error) {
                message.info("客户呼叫已挂断！")
                let cancelRs = actions.cancelServiceRequestInitiate(customer._id);
                let cancelRs2 = actions.cancelServiceRequestFinish(customer._id)

                // actions.endSessionByPicc(customer._id);
            } else {
                this.props.actions.sessionReqType(dashBoardTypes.currentSession)
                this.props.actions.currentCallReqAction(this.props.call, this.props.customer)
                this.props.actions.currentCallStatus('show')
            }
        } else  if (customer.isSessionActive) {
            //微信小程序渠道，退出房间时调用
            if(customer.channelType == 'wxSmallProgram'){
                window.postMessage({cmd: 'invoke', code: 'sendRemoveStreamToBackground()'}, '*')
            } else if (customer.channelType.indexOf('mcu') > -1) {

                conference.conference.leave();
            } else if (customer.channelType.indexOf('trtc') > -1) {
                sendTrtcMessageTowxSmallProgram({ requestId: customer._id, subType: 'hangUp' });
            } else {
                actions.endKandyCall(customer.userId, call.callId)
                actions.sendMessage(customer.userId, "", {additionalData: {"type": "control", "session": "ended"}})
            }
            actions.endSessionByPicc(customer._id)
            actions.isOrNoUserInfo(userInfoType.noneUserInfo)
            var tmpSessionStarted = this.state.sessionStarted;
            if (tmpSessionStarted.indexOf(customer.userId) > -1) {
                delete tmpSessionStarted[customer.userId]
            }
        } else if (customer.isEscalated) {//插队
            //微信小程序渠道，退出房间时调用
            if(customer.channelType == 'wxSmallProgram'){
                //关闭流
                window.postMessage({cmd: 'invoke', code: 'sendRemoveStreamToBackground()'}, '*')
            }
            if (call) {
                actions.endKandyCall(customer.userInfo.email, call.callId)
            }
            actions.endSessionByPicc(customer._id)
            actions.saveInfoBut(false)
        } else {
            this.setState({StartBtn: true});
            var tmpSessionStarted = this.state.sessionStarted;

            if (!tmpSessionStarted[customer.userId]) {
                tmpSessionStarted[customer.userId] = true
                this.setState({
                    sessionStarted: tmpSessionStarted
                });
            }
            else {
                return false
            }
            let rs = await actions.startSessionByPicc(customer._id, company.waitTime, currentAgent)
            /* 接听失败直接做挂断处理*/
            if (rs.error) {
                message.info("客户呼叫已挂断！")
                let cancelRs = actions.cancelServiceRequestInitiate(customer._id);
                let cancelRs2 = actions.cancelServiceRequestFinish(customer._id)

                // actions.endSessionByPicc(customer._id);
            } else {
                if (_.indexOf(currentAgent.permission, 'text') != -1 || _.indexOf(currentAgent.permission, 'voice') != -1
                    || _.indexOf(currentAgent.permission, 'video') != -1) {
                    this.props.actions.sessionReqType(dashBoardTypes.currentSession)
                }
                this.props.actions.currentCallReqAction(this.props.call, this.props.customer)
                this.props.actions.currentCallStatus('show')
                if (customer.channelType.indexOf('mcu') === -1 && customer.channelType.indexOf('trtc') === -1) {
                    this.handleMakeCall();
                }
            }
        }
        getStore().dispatch(currentCallActions.currentCallStatus('close'))
    }


    handleMakeCall(callType = 'video') {
        if (this.props.currentCallCount !== 0){
            message.info("正在与其他客户通话中...")
            return
        }
        this.props.actions.sendIsShowShade(this.props.customer.userId,true);
        const userAgent = window.navigator.userAgent.toLowerCase(),
            ios = /iphone|ipod|ipad/.test(userAgent),
            android = /android/i.test(userAgent)

        this.props.actions.sendCallDetails(this.props.customer.userId, callType)

        if (!ios) {
            var isCameraOn = callType === 'video' ? true : false
            if (android) this.permitCamera()
            this.props.actions.makeKandyCall(this.props.customer.userId, false, {}, {
                remoteVideoContainer: 'remote-media-container',
                localVideoContainer: 'local-media-container'
            })
        }
    }

    permitCamera() {
        navigator.getUserMedia = navigator.getUserMedia ||
            navigator.webkitGetUserMedia ||
            navigator.mozGetUserMedia ||
            navigator.msGetUserMedia
        navigator.getUserMedia({
            audio: true,
            video: true
        }, stream => stream.getVideoTracks().map(obj => obj.stop()), err => err)
    }

    UNSAFE_componentWillReceiveProps(nextProps){
        if (nextProps.call) {
            nextProps.actions.currentCallReqAction(nextProps.call, nextProps.customer)
            nextProps.actions.currentCallStatus('show')
        }
    }


    render() {
        const { customer, currentReport, } = this.props;
        var sessionDiv
        if (customer.connected == false) {
            this.doCustomerDisconnected.bind(this)
            return (<div />)
        }
        // customer.isSessionActive = true;
        if (customer.isSessionActive) {
            sessionDiv = (
                <div className="end-session-wrapper">
                    <Button type="primary" onClick={this.toggleSession.bind(this)} className="end-session">
                            挂断
                    </Button>
                </div>
            )
        } else {
                sessionDiv = (
                    <div className="start-session-wrapper">
                        <Button className="start-session" disabled={this.state.StartBtn} onClick={this.toggleSession.bind(this)} style={{position:'relative',top:-20}}>
                            {/*<TxtIcon name="start" text={t('Session::start')} size="xs"/>*/}
                            接受
                        </Button>
                    </div>
                )
        }
        return (
            <div className="session-actions">
                {sessionDiv}
            </div>
        )
    }
}


let mapStateToProps = (state, props) => {
    return Object.assign({}, props, {conference: state.app.conference})
};

let mapDispatchToProps = (dispatch, props) => {
    return {
        actions: props.actions
    }
};

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(LossKandySessionAction)
